import { render, staticRenderFns } from "./procurementGuidelines.vue?vue&type=template&id=ce63ca26"
import script from "./procurementGuidelines.vue?vue&type=script&lang=js"
export * from "./procurementGuidelines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports